// ════════════════════════════════════════════════════════════════════════════
// integracaoMs.service.js — r160
// Cliente HTTP pra endpoints de integração Microsoft.
// ════════════════════════════════════════════════════════════════════════════
import { api } from './auth.service';

const integracaoMsService = {
  // Retorna { conectado: true/false, ms_email?, ms_nome?, ... }
  status: async () => {
    const res = await api.get('/integracao-ms/status');
    return res.data;
  },

  // Não retorna nada — frontend faz window.location pra essa URL
  // (precisa de redirect HTTP, não dá pra fazer via axios)
  urlIniciar: (usuario_id) => {
    const base = api.defaults.baseURL || '';
    return `${base}/integracao-ms/iniciar?usuario_id=${encodeURIComponent(usuario_id)}`;
  },

  desconectar: async () => {
    const res = await api.delete('/integracao-ms/desconectar');
    return res.data;
  },
};

export default integracaoMsService;
